// Action Types
export const types = {
  SET_PAGE_TITLE: 'careV2/SET_PAGE_TITLE',
  CLEAR_PAGE_TITLE: 'careV2/CLEAR_PAGE_TITLE',
}

// Action Creators
/**
 * Action creator to set the page title
 *
 * @param {string} title - The title to set for the page
 * @returns {Object} SET_PAGE_TITLE action with title payload
 */
export const setPageTitle = title => ({
  type: types.SET_PAGE_TITLE,
  payload: { title },
})

/**
 * Action creator to clear the page title to the default value
 *
 * @returns {Object} CLEAR_PAGE_TITLE action
 */
export const clearPageTitle = () => ({
  type: types.CLEAR_PAGE_TITLE,
})

// Initial State
export const initialState = {
  pageTitle: '', // Default empty page title
}

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action.payload.title,
      }

    case types.CLEAR_PAGE_TITLE:
      return {
        ...state,
        pageTitle: initialState.pageTitle,
      }

    default:
      return state
  }
}
